import {Component, EventEmitter, Output, ViewEncapsulation} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {Subject, takeUntil} from 'rxjs';
import {AuthService} from "@coreApiServices";
import {LoaderService, ToastService} from "@coreServices";
import {CommonConstants, ROUTES} from "@coreConstant";
import {ResetPasswordModel} from '@coreModels';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss', '../auth.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent {
  submitted!: boolean;
  resetPasswordForm!: any;
  resetToken = '';
  @Output() type: EventEmitter<string> = new EventEmitter();
  destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private toastService: ToastService,
    public loaderService: LoaderService,
    private activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
    const resetPasswordToken = this.router.url.split('/');
    if (resetPasswordToken.length > 0) {
      this.resetToken = resetPasswordToken[resetPasswordToken.length - 1];
    }
    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6), this.noWhitespaceValidator]],
      confirm_password: ['', [Validators.required, this.passwordMatcher.bind(this), this.noWhitespaceValidator]]
    });
    this.f['password'].valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.f['confirm_password'].updateValueAndValidity());
  }

  noWhitespaceValidator(control: any) {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : {'whitespace': true};
  }

  private passwordMatcher(control: any): { [s: string]: boolean } {
    if (this.resetPasswordForm && (control.value !== this.f['password'].value)) {
      return {passwordNotMatch: true};
    }
    return {};
  }

  get f() {
    return this.resetPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetPasswordForm.invalid) return;

    let resetPasswordModel = new ResetPasswordModel();
    resetPasswordModel.password_reset_token = this.resetToken;
    resetPasswordModel.password = this.resetPasswordForm.value.password;
    resetPasswordModel.client_id = environment.FRONTEND_CLIENT_ID;

    this.loaderService.show();
    this.authService.resetPassword(resetPasswordModel).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.submitted = false;
        this.resetPasswordForm.reset();
        this.toastService.showSuccess(CommonConstants.SUCCESS_RESET_PASSWORD);
        this.activeModal.close();
        this.router.navigate(['/' + ROUTES.LOGIN]);
      },
      error: (error) => {
        this.toastService.showError(error.error.data.message);
        this.loaderService.hide();
      },
      complete: () => {
        this.loaderService.hide();
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
